import React, { useEffect, useRef, useState } from 'react';
import './Input.scss';

function Input({
  type,
  label,
  onChangeCallback,
  error,
  inputId,
  inputSelected,
  extClasses,
  resetField,
  children,
}) {
  const [inputVal, setInputVal] = useState(inputSelected || '');
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputSelected !== inputVal) {
      setInputVal(inputSelected || '');
    }
  }, [inputSelected]);

  useEffect(() => {
    if (resetField !== undefined) {
      setInputVal('');
    }
  }, [resetField]);

  function handleInputVal(e) {
    setInputVal(e.target.value);
    inputRef.current.classList.remove('error_highlight_input');
    onChangeCallback && onChangeCallback(e.target.value);
  }

  return (
    <div className={`input_container ${extClasses}`}>
      <input
        id={inputId}
        autoComplete="off"
        type={type}
        className={`input_field ${error ? 'error_highlight_input' : ''}`}
        onChange={handleInputVal}
        value={inputVal}
        ref={inputRef}
      />
      <label
        htmlFor={inputId}
        className={`floating_label ${inputVal ? 'activeWithData' : null} ${error ? 'error' : ''}`}>
        {label}
      </label>
      {error && (
        <div className="input_error">{error && <span className="error_message">{error}</span>}</div>
      )}
      {children}
    </div>
  );
}

export default Input;
